import { render, staticRenderFns } from "./FormContinue.vue?vue&type=template&id=c848f8c0"
import script from "./FormContinue.vue?vue&type=script&lang=js"
export * from "./FormContinue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports